import {
  Button,
  Card,
  CardActions,
  CardContent,
  colors,
  Modal,
} from "@material-ui/core";
import React from "react";
import * as Sentry from "@sentry/browser";

import clsx from "clsx";

import { makeRequest } from "../../../util";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

import { useModalStyles } from "../../modals/styles";
import { RedditIcon } from "../../../components/icons/themes/logos";

const AccountIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig = {},
}) => {
  const { settings: allSettings } = existingConfig;

  return (
    <ConfigureDestinationsModal
      limitSettings={["accountId"]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const AccountIDRow = ({ setConfigModalOpen, existingConfig = {} }) => {
  const idSet = "accountId" in existingConfig.settings;

  return (
    <DestinationConfigRow
      name="Account ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthModal = ({ open, onClose, existingConfig = {} }) => {
  const classes = useModalStyles();

  const onRunOauth = () => {
    makeRequest("get_oauth_url", {
      integration_name: "reddit-ads",
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        window.location = response.data;
      })
      .catch((error) => {
        console.log(error);
        Sentry.captureException(error);
        alert.error("Something went wrong. Unable to setup Reddit Ads.");
      });
  };

  return (
    <Modal open={open} onRequestClose={onClose}>
      <Card className={clsx(classes.root, classes.smallModal)}>
        <CardContent className={classes.modalContent}>
          Freshpaints’s use and transfer to any other app of information
          received from Reddit APIs will adhere to&nbsp;
          <a
            className="underline"
            style={{ color: "blue" }}
            href="https://business.reddithelp.com/helpcenter/s/article/Reddit-Ads-API-Terms"
          >
            Reddit Ads API terms
          </a>
          .
        </CardContent>
        <CardActions className={classes.actions}>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" variant="contained" onClick={onRunOauth}>
            <RedditIcon
              className="mr-2 fill-white position"
              height="2em"
              style={{ top: -2 }}
            />
            Connect With Reddit
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

const OAuthRow = ({ setConfigModalOpen, existingConfig = {} }) => {
  const config = existingConfig.settings;
  const oauthConfigured = "oauthToken" in config;
  // only show the oauth flow if we're in server side mode
  var enable_row = existingConfig.connection_mode !== "server";

  var icon = (
    <RedditIcon
      className="mr-2 fill-white position"
      height="2em"
      style={{ top: -2 }}
    />
  );

  const loginButton = (
    <Button
      className="rounded text-grey px-2 py-1 w-auto inline-block cursor-pointer font-semi-bold"
      onClick={setConfigModalOpen}
      color="primary"
      variant="outlined"
    >
      {!oauthConfigured && icon}
      {oauthConfigured ? "Reconnect" : "Connect With Reddit"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access Permission"
      disabled={enable_row}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const ACCOUNT_ID = "ACCOUNT_ID";
const OAUTH = "OAUTH";

const Rows = {
  [ACCOUNT_ID]: AccountIDRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [ACCOUNT_ID]: AccountIDModal,
  [OAUTH]: OAuthModal,
};

const RowOrder = [ACCOUNT_ID, OAUTH];

export default { Rows, RowOrder, Modals };
